import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    .login-container {
      min-width: 30rem;
      max-width: 50rem;
      margin-left: auto;
      margin-right: auto;
    }

    .login-panel {
      text-align: center;
      border-radius: 3px;
      box-shadow: 0 .375em 1em rgba(0, 0, 0, .25);
      background: #ffffff;
    }

    .login-container .login-panel {
      padding: 4rem 3rem 4rem 3rem;
    }

    .login-container .login-panel img {
      width: 22rem;
      height: auto;
    }

    .login-container .login-panel .panel-heading {
      background: #ffffff;
      padding-top: 2rem;
      padding-bottom: 1rem
    }

    .login-container .login-panel .panel-heading h2 {
      margin: 0;
      font-weight: 700;
      line-height: 1.2;
      color: #5B6062;
    }

    .login-container .login-panel .panel-body h4  {
      margin-bottom: 2rem;
      color: #5B6062;
    }

    .login-container .login-panel .panel-body .login-btn  {
      margin: 0;
    }

    .login-btn {
      --tenable-btn-primary-background-color: #1E2426;
      --tenable-btn-primary-border-color: #1E2426;
      --tenable-btn-primary-hover-background-color: #e7ff00;
      --tenable-button-width: fit-content;
    }
  `,
];
